import ManagingRoutes from "./managing";
import ReportingRoutes from "./reporting"

export default [
    ...ManagingRoutes,
    ...ReportingRoutes
];
